module.exports = __webpack_public_path__ + "img/gift-sertificate.bf74b3f9.png";